import { render, staticRenderFns } from "./IsogdDocInPoint.vue?vue&type=template&id=472c608e&scoped=true&"
import script from "./IsogdDocInPoint.vue?vue&type=script&lang=js&"
export * from "./IsogdDocInPoint.vue?vue&type=script&lang=js&"
import style0 from "./IsogdDocInPoint.vue?vue&type=style&index=0&id=472c608e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c608e",
  null
  
)

export default component.exports